import * as yup from "yup";

const isEmailSchema = yup.string().email();

const hmgSelect = {
  hotelManagementGroupId: yup
    .string()
    .required("Please Select Hotel Management Group !"),
  project: yup.string().required("Please Select Project !"),
  autoId: yup.string().required("Please Select Auto ID !"),
};

const RemindersSchema = yup.object().shape({
  notificationSchedules: yup.object({
    ...hmgSelect,
    schedules: yup.array().of(
      yup.object().shape({
        expirationDate: yup.string().required("Please Add Expiration Date!"),
        reminderDays: yup
          .number()
          .positive("Reminder Days must be a positive number")
          .typeError("Please Add Reminder Days!")
          .required("Please Add Reminder Days!")
          .min(1, "Reminder Days must be a positive number"),
        reminderDate: yup.string().required("Please Add Reminder Date!"),
        scheduleSet: yup.bool(),
        primaryRecipient: yup
          .array()
          .min(1, "Primary Alert Recipient cannot be empty!")
          .transform(function (value, originalValue) {
            if (this.isType(value) && value !== null) {
              return value;
            }
            return originalValue ? [originalValue] : [];
          })
          .test("test-Primary-Recipient-Validator", function (value) {
            const invalidInputs = value.find(
              (v) => !isEmailSchema.isValidSync(v),
            );
            return !invalidInputs
              ? true
              : this.createError({
                  message: `'${invalidInputs}'is not valid email`,
                });
          }),
        secondaryRecipient: yup
          .array()
          .transform(function (value, originalValue) {
            if (this.isType(value) && value !== null) {
              return value;
            }
            return originalValue ? originalValue.split(/[\s,]+/) : [];
          })
          .test("test-Primary-Recipient-Validator", function (value) {
            const invalidInputs = value.find(
              (v) => !isEmailSchema.isValidSync(v),
            );
            return !invalidInputs
              ? true
              : this.createError({
                  message: `'${invalidInputs}'is not valid email`,
                });
          }),
      }),
    ),
  }),
});
export default RemindersSchema;
